export default {
  en: {
    accounting: 'Accounting',
    '/accounting/accounts': 'Accounts',
    '/accounting/transactions': 'Transactions',
    companyManagement: 'Company Management',
    '/company/registers/close': 'Close Register',
    '/company/registers/open': 'Open Register',
    customers: 'Customers',
    '/customer/customers': 'Customers',
    hr: 'Human Resources',
    '/hr/employeeclocks': 'Clock in/Clock out',
    '/hr/employees': 'Employees',
    '/hr/employeeschedule': 'Employee Schedule',
    inventory: 'Inventory',
    '/inventory/inventoryadjustments': 'Inventory Adjustment',
    '/inventory/inventoryreceivings': 'Inventory Receiving',
    '/inventory/inventorytransfers': 'Inventory Transfer',
    '/inventory/itembrands': 'Brands',
    '/inventory/itemcategories': 'Categories',
    '/inventory/items': 'Items',
    '/inventory/itemtags': 'Tags',
    sales: 'Sales',
    '/sales/orderpayments': 'Order Payments',
    '/sales/orders': 'Orders',
    '/sales/applydiscount': 'Apply Discount',
    '/sales/discountcodes': 'Discount Codes',
    '/sales/returns': 'Return Orders',
    users: 'Employees',
    '/user/users': 'Employees',
    vendors: 'Vendors',
    '/accounting/registerstatus': 'Register Status',
    '/vendor/vendors': 'Vendors',
    '/accounting/company': 'Company Expenses',
    '/accounting/company/expensePayee': 'Expense Payee',
    '/accounting/company/expenseType': 'Expense Type',
    '/accounting/customerinvoices': 'Customer Invoices',
    '/accounting/customerinvoices/payments': 'Customer Invoices Payments',
    '/accounting/hr': 'HR Expenses',
    '/accounting/postings': 'Postings',
    '/accounting/registertransactions': 'Register Transactions',
    '/accounting/vendorbills': 'Vendor Bills',
    '/accounting/vendorbills/payments': 'Vendor Bills Payments',
    company: 'Company',
    '/company/locations': 'Locations',
    '/company/machines': 'Machines',
    '/company/register-actions': 'Register Actions',
    '/company/registers': 'Registers',
    '/company/registers/compute-closing-amount': 'Compute Register Closing Amount',
    '/company/registers/status': 'Registers Status',
    customer: 'Customer',
    helpers: 'Helpers',
    '/helpers/count': 'Count Rows',
    '/inventory/inventorytransactions': 'Inventory Transactions',
    reports: 'Reports',
    '/reports/accounting/profit-and-loss': 'Profit And Loss',
    '/reports/accounting/cash-assets': 'Cash Assets',
    '/reports/customer/customer-balance': 'Customer Balance',
    '/reports/customer/top-customers': 'Top Customers',
    '/reports/inventory-quantity': 'Inventory Quantity',
    '/reports/inventory-value': 'Inventory Value',
    '/reports/sales/end-of-day': 'End Of Day',
    '/reports/sales/heatmap': 'Heatmap',
    '/reports/sales/least-sold-items': 'Least Sold Items',
    '/reports/sales/sales-by-category': 'Sales By Category',
    '/reports/sales/sales-by-item': 'Sales By Item',
    '/reports/sales/sales-comparison': 'Sales Comparison',
    '/reports/sales/sales-summary': 'Sales Summary',
    '/reports/sales/top-sold-items': 'Top Sold Items',
    '/reports/vendor/top-vendors': 'Top Vendors',
    '/reports/vendor/vendor-balance': 'Vendor Balance',
    settings: 'Settings',
    '/settings': 'Global Settings',
    '/settings/permissions': 'Permissions',
    user: 'User',
    '/user/permissionusers': 'User Permissions',
    vendor: 'Vendor',
    '/customer/birthday-messages': 'Birthday Messages',
    '/examination/examinations': 'Examinations',
    '/examination/zeiss-cards': 'ZEISS Cards',
    '/inventory/itemcustompricetypes': 'Custom Price Types',
    '/reports/accounting': 'Accounting Reports',
    '/reports/customer': 'Customer Reports',
    '/reports/inventory': 'Inventory Reports',
    '/reports/sales': 'Sales Reports',
    '/reports/vendor': 'Vendor Reports',
    '/user/roles': 'Roles',
    '/settings/settings': 'Settings',
    '/reports/hremployee-attendance': 'Employee Attendance',
    '/reports/hrpaid-salaries': 'Paid Salaries',
    '/reports/hrtop-salaries': 'Top salaries Report',
    '/inventory/attributes': 'Attributes',
    '/reports/hr': 'HR Reports'
  },
  ar: {
    accounting: 'المحاسبة',
    '/accounting/accounts': 'الحسابات',
    '/accounting/transactions': 'الحركات المالية',
    companyManagement: 'ادارة الشركة',
    '/company/registers/close': 'غلق الصندوق',
    '/company/registers/open': 'فتح الصندوق',
    customers: 'الزبائن',
    '/customer/customers': 'الزبائن',
    hr: 'الموارد البشرية',
    '/hr/employeeclocks': 'تسجيل الدخول والخروج',
    '/hr/employees': 'ادارة الموظفين',
    '/hr/employeeschedule': 'جدول الموظفين',
    inventory: 'المخزن',
    '/inventory/inventoryadjustments': 'تعديل البضاعة',
    '/inventory/inventoryreceivings': 'استلام البضاعة',
    '/inventory/inventorytransfers': 'تحويل البضاعة',
    '/inventory/itembrands': 'العلامات التجارية',
    '/inventory/itemcategories': 'المجاميع',
    '/inventory/items': 'المنتجات',
    '/inventory/itemtags': 'الوسوم',
    sales: 'المبيعات',
    '/sales/orderpayments': 'دفعات المبيعات',
    '/sales/orders': 'المبيعات',
    '/sales/applydiscount': 'تطبيق الخصم',
    '/sales/discountcodes': 'شفرات الخصم',
    '/sales/returns': 'ارجاع المبيعات',
    users: 'الموظفين',
    '/user/users': 'الموظفين',
    vendors: 'المورّدون',
    '/accounting/registerstatus': 'حالة الخزنة',
    '/vendor/vendors': 'المورّدون',
    '/accounting/company': 'الشركات',
    '/accounting/company/expensePayee': 'المصاريف المدفوعة',
    '/accounting/company/expenseType': 'انواع المصاريف',
    '/accounting/customerinvoices': 'فواتير الزبائن',
    '/accounting/customerinvoices/payments': 'مدفوعات فواتير الزبائن',
    '/accounting/hr': 'مصاريف الموارد البشرية',
    '/accounting/postings': 'Postings',
    '/accounting/registertransactions': 'الحراكات المالية لصناديق النقد',
    '/accounting/vendorbills': 'مصاريف المورّدون',
    '/accounting/vendorbills/payments': 'مدفوعات مصاريف المورّدون',
    company: 'الشركة',
    '/company/locations': 'المواقع والمتاجر',
    '/company/machines': 'الاجهزة',
    '/company/register-actions': 'عمليات صناديق النقد',
    '/company/registers': 'صناديق النقد',
    '/company/registers/compute-closing-amount': 'حساب مبلغ اغلاق الخزنة',
    '/company/registers/status': 'حالة صناديق النقد',
    customer: 'الزبون',
    helpers: 'المساعدة',
    '/helpers/count': 'حساب عدد الصفوف',
    '/inventory/inventorytransactions': 'عمليات المخزون',
    reports: 'التقارير',
    '/reports/accounting/profit-and-loss': 'الربح والخسارة',
    '/reports/accounting/cash-assets': 'الأصول النقدية',
    '/reports/customer/customer-balance': 'رصيد الزبون',
    '/reports/customer/top-customers': 'افضل الزبائن',
    '/reports/inventory-quantity': 'كمية المخزون',
    '/reports/inventory-value': 'قيمة المخزون',
    '/reports/sales/end-of-day': 'نهاية اليوم',
    '/reports/sales/heatmap': 'خريطة الحرارة',
    '/reports/sales/least-sold-items': 'المنتجات الاقل مبيعا',
    '/reports/sales/sales-by-category': 'المبيعات حسب الفئة',
    '/reports/sales/sales-by-item': 'المبيعات حسب المنتج',
    '/reports/sales/sales-comparison': 'مقارنة المبيعات',
    '/reports/sales/sales-summary': 'ملخص المبيعات',
    '/reports/sales/top-sold-items': 'اكثر المنتجات بيعا',
    '/reports/vendor/top-vendors': 'افضل المخازن',
    '/reports/vendor/vendor-balance': 'رصيد المخزن',
    settings: 'الاعدادات',
    '/settings': 'الاعدادات العامة',
    '/settings/permissions': 'الصلاحيات',
    user: 'المستخدم',
    '/user/permissionusers': 'صلاحيات المستخدم',
    vendor: 'المخزن',
    '/customer/birthday-messages': 'رسائل اعياد الميلاد',
    '/examination/examinations': 'الفحوصات',
    '/examination/zeiss-cards': 'بطاقات ZEISS',
    '/inventory/itemcustompricetypes': 'الاسعار الاخرى',
    '/reports/accounting': 'تقارير المحاسبة',
    '/reports/customer': 'تقارير الزبائن',
    '/reports/inventory': 'تقارير المخزن',
    '/reports/sales': 'تقارير المبيعات',
    '/reports/vendor': 'تقارير المورّدون',
    '/user/roles': 'المناصب والصلاحيات',
    '/settings/settings': 'الاعدادات',
    '/reports/hremployee-attendance': 'تقارير حضور الموظفين',
    '/reports/hrpaid-salaries': 'تقارير الرواتب',
    '/reports/hrtop-salaries': 'تقارير اعلى الرواتب',
    '/inventory/attributes': 'الاصناف',
    '/reports/hr': 'تقارير الموارد البشرية'
  }
}
